export default "__VITE_ASSET__7a4ccb87__"